import styled from 'styled-components';

const Label = styled.div`
  font-weight: 500;
  font-size: 14px;
  /* margin-top: 10px; */
  margin-bottom: 1px;
  color: #343c6a;
`;

const LabelComponent = ({ title }) => {
  return <Label>{title}</Label>;
};

export default LabelComponent;
